import { IHisItemAction } from ".";
import { HisInformation, HisInformationItem } from "..";
import { IDocumentEditable } from "../../../components/document/editor";
import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "../../document/items";
import { User } from "../../user";
import { HisInformationUpdateEveryTimeMaster } from "../master";

export class HisItemFormatUpdateAction implements IHisItemAction {
  applicableItems: IHisInformationApplicable[][];
  informationItems: HisInformationItem[];
  managerIds: string[];
  
  constructor(document: IDocumentEditable, info: HisInformation, user: User, hostName: string) {
    // 現状では最低限のオブジェクトしか更新しないが、
    // 作成日・作成者を更新する場合はワークフロー側の機能と競合しないように注意が必要
    this.applicableItems = this.getApplicableItems(document);
    this.informationItems = this.getInformationItems(info, user, hostName);
    this.managerIds = info.managerIds;
  }

  private getApplicableItems(document: IDocumentEditable): IHisInformationApplicable[][] {
    const items = document.itemSets.map(itemSet => itemSet.items
      .filter(instanceOfIHisInformationApplicable)
      .filter(item => item.hisItemParameter != null)
      .filter(item => this.shouldAppliedUpdate(item))
    );
    return items;
  }
  
  private shouldAppliedUpdate(item: IHisInformationApplicable): boolean {
    return HisInformationUpdateEveryTimeMaster.isUpdateEveryTime(item.hisItemParameter.key);
  }

  private getInformationItems(info: HisInformation, user: User, hostName: string): HisInformationItem[] {
    const items: HisInformationItem[] = [];
    // LAST_UPDATE_DATEはFilledCreateDateBehavior内で自動生成する
    items.push(new HisInformationItem("LAST_UPDATE_USER", user.name));
    items.push(new HisInformationItem("USER_ACCOUNT", user.id));
    items.push(new HisInformationItem("HOST_NAME", hostName ? hostName : ""));
    return items;
  }
}
